import { HStack } from '@rbilabs/universal-components';

export const ProductPriceCaloriesContainer = HStack.withConfig({
  width: 'full',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: 0,
  marginBottom: 3,
  space: '$2',
});
